import { render, staticRenderFns } from "./ChallengeSelectedCelebrationPopup.vue?vue&type=template&id=151de280&scoped=true"
import script from "./ChallengeSelectedCelebrationPopup.vue?vue&type=script&lang=js"
export * from "./ChallengeSelectedCelebrationPopup.vue?vue&type=script&lang=js"
import style0 from "./ChallengeSelectedCelebrationPopup.vue?vue&type=style&index=0&id=151de280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151de280",
  null
  
)

export default component.exports